import { Button, Text } from '@mantine/core';
import { modals } from '@mantine/modals';

const ConfirmModal = ({ confirmButtonColor, confirmButtonIcon, prompt, title, confirmButtonText, cancelButtonText, handleCancel, handleConfirm, triggerModalButtonColor, triggerModalButtonText, triggerModalButtonIcon }) => {
  const openModal = () =>
    modals.openConfirmModal({
      title: title,
      centered: true,
      children: (
        <Text size="sm">
          {prompt}
        </Text>
      ),
      labels: { confirm: confirmButtonText, cancel: cancelButtonText },
      confirmProps: { color: confirmButtonColor, leftIcon: confirmButtonIcon },
      onCancel: handleCancel,
      onConfirm: handleConfirm,
    });

  return <Button onClick={openModal} compact color={triggerModalButtonColor}>{triggerModalButtonIcon}&nbsp;{triggerModalButtonText}</Button>;
}

export default ConfirmModal;